import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import CustomTable from '../misc/CustomTable';
import { GridColDef } from '@mui/x-data-grid';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { useAppDispatch, useAppSelector } from '../../store';
import { getContactsByRobotId } from '../../store/robots/robots-actions';
import { selectRobotsData } from '../../store/robots/robots-slice-selectors';

const RobotContactPerson: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const robotsData = useAppSelector((state) => selectRobotsData(state));

  useEffect(() => {
    if (
      robotsData.rest.getContactsStatus === HttpFetchStatus.Idle &&
      robotsData.selectedId != null
    ) {
      dispatch(getContactsByRobotId(robotsData.selectedId));
    }
  }, [dispatch, robotsData.rest.getContactsStatus, robotsData.selectedId]);

  const columns: GridColDef[] = [
    { field: 'name', headerName: t('table-header-name') as string },
    { field: 'email', headerName: t('table-header-email') as string, width: 250 },
    { field: 'phoneNumber', headerName: t('table-header-phone-number') as string },
    { field: 'organizationName', headerName: t('table-header-organization') as string },
  ];

  return (
    <React.Fragment>
      <Stack spacing={2}>
        <CustomTable
          autoHeight
          getStatus={robotsData.rest.getContactsStatus}
          loadingMessage={t('loading-users')}
          dataLoaded={robotsData.currentRobotData.contacts != null}
          failedToLoadMessage={t('error-loading-users')}
          data={robotsData.currentRobotData.contacts ?? []}
          emptyDataMessage={t('info-no-robot-contact-people')}
          columns={columns}
          hideFooter
        />
      </Stack>
    </React.Fragment>
  );
};

export default RobotContactPerson;
